import {observer} from "mobx-react";
import {Component} from "react";
import styles from "../index.css";
import {scenario} from "../../../stores";
import PathPopupUnit from "../PathPopupUnit";
import {Drop} from "../../DragNDrop";
import React from "react";

@observer
export default class PathBody extends Component{
    render(){
        return(
            <div className={styles.pathBody}>
                <div className={styles.scrollablePath}>
                    {scenario.script.map((item,i)=>{
                        return (
                            <div className={styles.itemContainer} key={i}>
                                <PathPopupUnit {...item}
                                               id={i}
                                               drop={this.props.drop}
                                               onMouseOver={()=>{this.props.setHoverElement(item,i,'path')}}
                                               active={this.props.hoveredDom === 'path' && this.props.hoverId === i}/>
                                <div className={styles.dropDownContainer} style={{display:(i === scenario.script.length-1 ? "none" : '') }}>
                                    <Drop
                                        className={styles.dropfield}
                                        id={i}
                                        onDrop={()=>{scenario.addScriptElem(this.props.drop,i)}}
                                        type={"intermediate"}>
                                        <div className={styles.dropPlace} />
                                    </Drop>
                                    <div className={styles.pathPlus + ' ' + styles.pathBodyElement}>+</div>
                                </div>
                            </div>
                        )})
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/PathPopupBody/index.js